<template>
    <section class="seat-row" :class="`seats${seatCountOnRow} ${hasEmergencyExit}`">
        <div v-if="this.hasEmergencyExit" class="emergency--exit"></div>
        <Seat v-for="(seat, index) in seats" :seat="seat"  :key="`${seat.designator}__${index}`" :priceMap="priceMap" :text="text" :styling="styling" :columns="seats.length"/>
    </section>
</template>
<script>
// import { mapGetters } from 'vuex'
import '@fortawesome/fontawesome-free/css/all.css'
import Seat from './Seat'
export default {
  props: ['seats', 'flightid', 'seatCountOnRow', 'priceMap', 'text', 'styling'],
  components: {
    Seat
  },
  computed: {
    // ...mapGetters(['flight', 'seatCountOnRow']),
    hasEmergencyExit () {
      return this.seats[0].emergencyExit ? 'emergencyExit' : ''
    }
  }
}
</script>
<style >
    #ss-container .seat-row {
      width: 100%;
      position: relative;
      /*height: 32px;*/
      margin: 10px 0 0;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -ms-align-items: center;
      align-items: center;
      justify-content: space-between;
      /*background-color: #FFFFFF;*/
    }
    #ss-container .seat-row.seats7 {
      height: 36px;
    }
    #ss-container .seat-row.seats9 {
      height: 25px;
    }
    #ss-container .seat-row.seats11 {
      height: 22px;
    }
    #ss-container .seat-row.seats12 {
      height: 22px;
    }
    #ss-container .emergency--exit {
        width: 103%;
        position: absolute;
        top: 0;
        left: -4px;
        right: 0;
        height: 20px;
        border-left: 4px solid #000000;
        border-right: 4px solid #000000;
    }
    #ss-container .emergency--exit:before {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      position: absolute;
      content: '\f060';
      width: 20px;
      height: 20px;
      font-size: 13px;
      left: -25px;
      top: 0;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -ms-align-items: center;
      align-items: center;
      justify-content: center;
    }
    #ss-container .emergency--exit:after {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      position: absolute;
      content: '\f061';
      width: 20px;
      height: 20px;
      font-size: 13px;
      right: -25px;
      top: 0;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -ms-align-items: center;
      align-items: center;
      justify-content: center;
    }
    #ss-container .emergencyExit {
      margin: 30px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Row.vue